<script>
import PaypalCardContent from './comp_PaypalCardContent.vue'
export default {
	props: ['order', 'checkout'],
	extends: PaypalCardContent,
}
</script>
